import { BackButton } from "@/components/BackButton";
import { HeaderButtons } from "@/components/layout/HeaderButtons";

/**
 * Header component for admin pages with back button and menu.
 * Back button navigates to /buildings (main app).
 */
export function AdminHeader() {
  return (
    <div className="flex items-center gap-2">
      <BackButton smart />
      <HeaderButtons />
    </div>
  );
}
